export const initialState = {}

export const checkAppState = () => (dispatch, getState, { httpRequest }) => {

  return httpRequest.get('/check-state')
    .then(res => {
       return Promise.resolve(res.data)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const ACTION_HANDLERS = {}

export default function(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/cookies.js